export * from './consultationType.service';